export const HAND_COMBOS = [
    {
        id: 'the-singularity',
        name: 'The Singularity',
        description: 'Five cards in sequence, all of the same suit. The perfect trade.',
        example: '5♠ 6♠ 7♠ 8♠ 9♠',
        baseScore: 160,
        multiplier: 4,
    },
    {
        id: 'sybil-attack',
        name: 'Sybil Attack',
        description: 'Four cards of the same rank. Maximum airdrop farming.',
        example: 'K♠ K♥ K♦ K♣',
        baseScore: 140,
        multiplier: 3.6,
    },
    {
        id: 'vc-full-bag',
        name: 'VC Full Bag',
        description: 'Three of a kind plus a pair. Pre-seed, seed, and Series A.',
        example: 'J♠ J♥ J♦ 4♣ 4♠',
        baseScore: 120,
        multiplier: 3.2,
    },
    {
        id: 'chain-maxi',
        name: 'Chain Maxi',
        description: 'Five cards of the same suit. One chain to rule them all.',
        example: '2♥ 5♥ 8♥ J♥ A♥',
        baseScore: 110,
        multiplier: 3,
    },
    {
        id: 'bull-run',
        name: 'Bull Run',
        description: 'Five cards in sequence. Number only goes up.',
        example: '4♠ 5♥ 6♦ 7♣ 8♠',
        baseScore: 100,
        multiplier: 2.7,
    },
    {
        id: 'triple-top',
        name: 'Triple Top',
        description: "Three cards of the same rank. Surely it won't dump.",
        example: '9♠ 9♥ 9♦',
        baseScore: 90,
        multiplier: 2.4,
    },
    {
        id: 'double-bottom',
        name: 'Double Bottom',
        description: 'Two different pairs. Ready to rip.',
        example: 'A♠ A♥ 7♦ 7♣',
        baseScore: 70,
        multiplier: 1.6,
    },
    {
        id: 'twin-rugs',
        name: 'Twin Rugs',
        description: 'Two cards of the same rank. Somehow still profitable.',
        example: 'Q♠ Q♥',
        baseScore: 50,
        multiplier: 1.5,
    },
    {
        id: 'exit-liquidity',
        name: 'Exit Liquidity',
        description: 'High card - no matching ranks. Thanks for your service.',
        example: 'A♠ K♥ 9♦',
        baseScore: 30,
        multiplier: 1,
    },
];
export const describeJokerEffect = (effect) => {
    switch (effect.kind) {
        case 'flatScore':
            return `+${effect.amount} score`;
        case 'percentScore':
            return `+${Math.round(effect.percent * 100)}% total score`;
        case 'scorePerHeart':
            return `+${Math.round(effect.percentPerHeart * 100)}% per heart`;
        case 'handTypeFlat':
            return `+${effect.amount} when playing ${effect.hand}`;
        case 'handTypePercent':
            return `+${Math.round(effect.percent * 100)}% when playing ${effect.hand}`;
        case 'chipsOnClear':
            return `+${effect.amount} chips on clear`;
        case 'heartsOnClear':
            return `+${effect.amount} heart${effect.amount === 1 ? '' : 's'} on clear`;
        case 'chipsOnFail':
            return `+${effect.amount} chips on fail`;
        case 'forceSuit':
            return `Transforms played cards into the ${effect.suit} suit`;
        case 'opponentHeartDamageOnClear':
            return `Deal ${effect.amount} heart damage to opponent on clear`;
        case 'heartStealOnClear':
            return `Steal ${effect.amount} heart${effect.amount === 1 ? '' : 's'} from opponent on clear`;
        case 'freezeOpponentOnClear':
            return 'Freeze opponent for 1 turn on clear';
        default:
            return 'Bonus effect';
    }
};
export const describeConsumableEffect = (effect) => {
    switch (effect.kind) {
        case 'addChips':
            return `Gain ${effect.amount} chips instantly`;
        case 'addHearts':
            return `Gain ${effect.amount} heart${effect.amount === 1 ? '' : 's'}`;
        case 'addDraws':
            return `+${effect.amount} draw${effect.amount === 1 ? '' : 's'} this blind`;
        case 'addDiscards':
            return `+${effect.amount} discard${effect.amount === 1 ? '' : 's'} this blind`;
        case 'scoreMultiplier':
            return `+${Math.round(effect.percent * 100)}% multiplier next hand`;
        case 'opponentHeartDamage':
            return `Deal ${effect.amount} heart damage to opponent`;
        default:
            return 'Special effect';
    }
};
export const JOKER_POOL = [
    // =====================
    // BASE JOKERS WITH EVOLUTION PATHS
    // =====================
    {
        id: 'diamond-hands',
        name: 'Diamond Hands',
        description: 'The more you HODL, the more you earn. Never selling.',
        rarity: 'common',
        cost: 120,
        maxCopies: 1,
        effects: [{ kind: 'scorePerHeart', percentPerHeart: 0.15 }],
        tags: ['economy'],
        evolution: {
            tier: 'base',
            nextEvolution: {
                condition: {
                    kind: 'heartsAbove',
                    description: 'HODL through 4 hands at 3+ hearts',
                    minHearts: 3,
                    triggerCount: 4,
                },
                evolvesTo: 'whale-wallet',
            },
        },
    },
    {
        id: 'validator-rewards',
        name: 'Validator Rewards',
        description: 'Every epoch deposits a generous stash of SOL.',
        rarity: 'common',
        cost: 140,
        maxCopies: 1,
        effects: [{ kind: 'chipsOnClear', amount: 120 }],
        tags: ['economy'],
        evolution: {
            tier: 'base',
            nextEvolution: {
                condition: {
                    kind: 'chipsEarned',
                    description: 'Earn 500 chips staking',
                    target: 500,
                },
                evolvesTo: 'mega-validator',
            },
        },
    },
    {
        id: 'paper-hands',
        name: 'Paper Hands',
        description: 'Even weak hands can shimmer with small gains. Sold too early again.',
        rarity: 'common',
        cost: 110,
        maxCopies: 2,
        effects: [
            { kind: 'handTypeFlat', hand: 'Exit Liquidity', amount: 40 },
            { kind: 'percentScore', percent: 0.1 },
        ],
        tags: ['utility'],
        evolution: {
            tier: 'base',
            nextEvolution: {
                condition: {
                    kind: 'handTypeCount',
                    description: 'Play 5 Exit Liquidity hands',
                    handType: 'Exit Liquidity',
                    target: 5,
                },
                evolvesTo: 'diamond-convert',
            },
        },
    },
    {
        id: 'fomo-buy',
        name: 'FOMO Buy',
        description: "Green candle? APE IN. Red candle? It's just a dip bro.",
        rarity: 'common',
        cost: 125,
        maxCopies: 2,
        effects: [
            { kind: 'percentScore', percent: 0.12 },
            { kind: 'chipsOnClear', amount: 35 },
        ],
        tags: ['aggressive'],
        evolution: {
            tier: 'base',
            nextEvolution: {
                condition: {
                    kind: 'consecutiveClears',
                    description: 'Hit 3 green candles in a row',
                    target: 3,
                },
                evolvesTo: 'full-degen',
            },
        },
    },
    {
        id: 'dca-bot',
        name: 'DCA Bot',
        description: 'Stack sats. Stack SOL. Time in market beats timing.',
        rarity: 'common',
        cost: 115,
        maxCopies: 2,
        effects: [
            { kind: 'percentScore', percent: 0.06 },
            { kind: 'chipsOnClear', amount: 45 },
        ],
        tags: ['economy'],
        evolution: {
            tier: 'base',
            nextEvolution: {
                condition: {
                    kind: 'triggerCount',
                    description: 'DCA 6 times',
                    target: 6,
                },
                evolvesTo: 'accumulation-whale',
            },
        },
    },
    {
        id: 'cold-wallet',
        name: 'Ledger on Solana',
        description: 'Not your keys, not your coins. Hardware wallet peace of mind.',
        rarity: 'common',
        cost: 105,
        maxCopies: 1,
        effects: [
            { kind: 'scorePerHeart', percentPerHeart: 0.08 },
            { kind: 'flatScore', amount: 20 },
        ],
        tags: ['defensive'],
    },
    {
        id: 'rekt-insurance',
        name: 'Rekt Insurance',
        description: "Win or lose, the grind continues. We're so back.",
        rarity: 'common',
        cost: 130,
        maxCopies: 1,
        effects: [
            { kind: 'chipsOnClear', amount: 55 },
            { kind: 'chipsOnFail', amount: 35 },
        ],
        tags: ['economy'],
        evolution: {
            tier: 'base',
            nextEvolution: {
                condition: {
                    kind: 'chipsEarned',
                    description: 'Survive 400 chips worth of losses',
                    target: 400,
                },
                evolvesTo: 'bankruptcy-phoenix',
            },
        },
    },
    {
        id: 'nft-flipper',
        name: 'NFT Flipper',
        description: "Buy floor, list 2x. Works until it doesn't.",
        rarity: 'common',
        cost: 135,
        maxCopies: 1,
        effects: [
            { kind: 'handTypePercent', hand: 'Twin Rugs', percent: 0.2 },
            { kind: 'chipsOnFail', amount: 25 },
        ],
        tags: ['utility'],
    },
    {
        id: 'whitepaper-reader',
        name: 'Whitepaper Reader',
        description: 'Actually reads the docs. Revolutionary concept.',
        rarity: 'common',
        cost: 130,
        maxCopies: 1,
        effects: [
            { kind: 'handTypeFlat', hand: 'Exit Liquidity', amount: 50 },
            { kind: 'percentScore', percent: 0.05 },
        ],
        tags: ['utility'],
    },
    {
        id: 'degen-chain',
        name: 'Degen Chain',
        description: 'Ape in, compound gains, ape into the next thing. This is the way.',
        rarity: 'uncommon',
        cost: 160,
        maxCopies: 1,
        effects: [{ kind: 'percentScore', percent: 0.25 }],
        tags: ['aggressive'],
        evolution: {
            tier: 'base',
            nextEvolution: {
                condition: {
                    kind: 'consecutiveClears',
                    description: 'Chain 3 successful apes',
                    target: 3,
                },
                evolvesTo: 'infinite-degen',
            },
        },
    },
    {
        id: 'jito-airdrop',
        name: 'Jito Airdrop',
        description: 'Wake up. Check wallet. Life changed. Free hearts for believers.',
        rarity: 'uncommon',
        cost: 180,
        maxCopies: 1,
        effects: [
            { kind: 'heartsOnClear', amount: 1 },
            { kind: 'flatScore', amount: 20 },
        ],
        tags: ['defensive'],
        evolution: {
            tier: 'base',
            nextEvolution: {
                condition: {
                    kind: 'triggerCount',
                    description: 'Receive 3 airdrops',
                    target: 3,
                },
                evolvesTo: 'jupiter-airdrop',
            },
        },
    },
    {
        id: 'bonk-army',
        name: 'Bonk Army',
        description: 'The dog coin of the people. Woof woof, numbers go up.',
        rarity: 'uncommon',
        cost: 170,
        maxCopies: 1,
        effects: [
            { kind: 'handTypePercent', hand: 'Twin Rugs', percent: 0.4 },
            { kind: 'chipsOnClear', amount: 60 },
        ],
        tags: ['aggressive'],
        evolution: {
            tier: 'base',
            nextEvolution: {
                condition: {
                    kind: 'scoreThreshold',
                    description: 'Score 400+ with Twin Rugs',
                    target: 400,
                },
                evolvesTo: 'wif-army',
            },
        },
    },
    {
        id: 'ct-alpha',
        name: 'CT Alpha',
        description: 'My mass DMs are OPEN. Trust me bro, this is the play.',
        rarity: 'uncommon',
        cost: 165,
        maxCopies: 1,
        effects: [
            { kind: 'handTypeFlat', hand: 'Exit Liquidity', amount: 80 },
            { kind: 'handTypePercent', hand: 'Exit Liquidity', percent: 0.15 },
        ],
        tags: ['utility'],
        evolution: {
            tier: 'base',
            nextEvolution: {
                condition: {
                    kind: 'handTypeCount',
                    description: 'Pump 4 Exit Liquidity hands',
                    handType: 'Exit Liquidity',
                    target: 4,
                },
                evolvesTo: 'whale-alpha',
            },
        },
    },
    {
        id: 'leverage-degen',
        name: 'Leverage Degen',
        description: "10x isn't enough. Let's make it 100x. What's the worst that could happen?",
        rarity: 'uncommon',
        cost: 185,
        maxCopies: 1,
        effects: [
            { kind: 'percentScore', percent: 0.18 },
            { kind: 'chipsOnClear', amount: 60 },
        ],
        tags: ['aggressive'],
    },
    {
        id: 'vc-whale',
        name: 'VC Whale',
        description: 'Building? No. Accumulating at lower prices than you.',
        rarity: 'uncommon',
        cost: 190,
        maxCopies: 1,
        effects: [
            { kind: 'handTypePercent', hand: 'Bull Run', percent: 0.22 },
            { kind: 'scorePerHeart', percentPerHeart: 0.06 },
        ],
        tags: ['combo', 'defensive'],
    },
    {
        id: 'memecoin-season',
        name: 'Memecoin Season',
        description: "Three matching coins? That's basically a moonshot.",
        rarity: 'uncommon',
        cost: 180,
        maxCopies: 1,
        effects: [
            { kind: 'handTypeFlat', hand: 'Triple Top', amount: 120 },
            { kind: 'chipsOnClear', amount: 40 },
        ],
        tags: ['combo'],
    },
    {
        id: 'hodl-strategy',
        name: 'HODL Strategy',
        description: "Red candles? I don't see red candles. *zooms out*",
        rarity: 'uncommon',
        cost: 175,
        maxCopies: 1,
        effects: [
            { kind: 'percentScore', percent: 0.2 },
            { kind: 'chipsOnFail', amount: 25 },
        ],
        tags: ['aggressive'],
    },
    {
        id: 'blue-chip-holder',
        name: 'JitoSOL Maxi',
        description: 'Liquid staking both sides. Earning yield in your sleep.',
        rarity: 'uncommon',
        cost: 185,
        maxCopies: 1,
        effects: [
            { kind: 'heartsOnClear', amount: 1 },
            { kind: 'chipsOnFail', amount: 30 },
        ],
        tags: ['defensive'],
    },
    {
        id: 'ghost-chain-bridger',
        name: 'Wormhole Bridger',
        description: "Moving funds through the multichain portal. Pray it doesn't get exploited again.",
        rarity: 'uncommon',
        cost: 185,
        maxCopies: 1,
        effects: [
            { kind: 'handTypeFlat', hand: 'Twin Rugs', amount: 90 },
            { kind: 'handTypePercent', hand: 'Exit Liquidity', percent: 0.18 },
        ],
        tags: ['utility'],
    },
    {
        id: 'kol-promoter',
        name: 'Solana KOL',
        description: "Paid tweet incoming. 'Best L1 and it's not even close.' NFA but definitely FA.",
        rarity: 'uncommon',
        cost: 205,
        maxCopies: 1,
        effects: [
            { kind: 'handTypePercent', hand: 'Chain Maxi', percent: 0.22 },
            { kind: 'chipsOnFail', amount: 35 },
        ],
        tags: ['combo', 'utility'],
    },
    {
        id: 'sniper-bot',
        name: 'Sniper Bot',
        description: 'First in, first out. Milliseconds matter.',
        rarity: 'uncommon',
        cost: 188,
        maxCopies: 1,
        effects: [
            { kind: 'handTypeFlat', hand: 'Bull Run', amount: 70 },
            { kind: 'percentScore', percent: 0.1 },
        ],
        tags: ['combo'],
    },
    {
        id: 'stop-loss',
        name: 'Stop Loss',
        description: 'Risk management is boring, but it works.',
        rarity: 'rare',
        cost: 200,
        maxCopies: 1,
        effects: [
            { kind: 'flatScore', amount: 100 },
            { kind: 'chipsOnFail', amount: 40 },
        ],
        tags: ['volatile'],
    },
    {
        id: 'flash-loan-attack',
        name: 'Raydium Flash Swap',
        description: 'Borrow, swap, profit — all in one Solana block. 400ms flat.',
        rarity: 'rare',
        cost: 220,
        maxCopies: 1,
        effects: [{ kind: 'handTypePercent', hand: 'Bull Run', percent: 0.3 }],
        tags: ['combo'],
    },
    {
        id: 'genz-quant-rug',
        name: 'GenZ Quant Rug',
        description: 'Thanks for the 20 bandos! *flips off camera*',
        rarity: 'rare',
        cost: 230,
        maxCopies: 1,
        effects: [
            { kind: 'percentScore', percent: 0.2 },
            { kind: 'chipsOnClear', amount: 50 },
        ],
        tags: ['aggressive'],
    },
    {
        id: 'mev-bot',
        name: 'MEV Bot',
        description: 'Front-running your way to profits. Nothing personal, kid.',
        rarity: 'rare',
        cost: 240,
        maxCopies: 1,
        effects: [
            { kind: 'handTypeFlat', hand: 'Bull Run', amount: 120 },
            { kind: 'handTypePercent', hand: 'Bull Run', percent: 0.2 },
        ],
        tags: ['combo'],
    },
    {
        id: 'hawk-tuah-coin',
        name: 'Hawk Tuah Coin',
        description: '95% down in hours. Hawk tuah! Spit on that portfolio.',
        rarity: 'rare',
        cost: 210,
        maxCopies: 1,
        effects: [
            { kind: 'heartsOnClear', amount: 1 },
            { kind: 'chipsOnFail', amount: 40 },
            { kind: 'flatScore', amount: 25 },
        ],
        tags: ['defensive'],
    },
    {
        id: 'mt-gox-distributions',
        name: 'FTX Estate Unlock',
        description: 'Three years in bankruptcy court. The SOL finally moves.',
        rarity: 'rare',
        cost: 215,
        maxCopies: 1,
        effects: [
            { kind: 'flatScore', amount: 90 },
            { kind: 'chipsOnFail', amount: 80 },
        ],
        tags: ['economy'],
    },
    {
        id: 'eight-dollar-solana',
        name: '$8 Solana',
        description: "Everyone laughed. Look who's laughing now.",
        rarity: 'rare',
        cost: 230,
        maxCopies: 1,
        effects: [
            { kind: 'handTypeFlat', hand: 'Bull Run', amount: 100 },
            { kind: 'chipsOnClear', amount: 70 },
        ],
        tags: ['combo'],
    },
    {
        id: 'voyager-bankruptcy',
        name: "Serum's Frozen Keys",
        description: 'FTX held the upgrade authority. One hack away from total protocol death.',
        rarity: 'rare',
        cost: 245,
        maxCopies: 1,
        effects: [
            { kind: 'percentScore', percent: 0.28 },
            { kind: 'chipsOnFail', amount: 50 },
        ],
        tags: ['aggressive'],
    },
    {
        id: 'short-squeeze',
        name: 'Short Squeeze',
        description: 'Shorts getting liquidated. You love to see it.',
        rarity: 'rare',
        cost: 225,
        maxCopies: 1,
        effects: [
            { kind: 'handTypePercent', hand: 'Exit Liquidity', percent: 0.25 },
            { kind: 'percentScore', percent: 0.1 },
        ],
        tags: ['utility'],
    },
    {
        id: 'multichain-maxi',
        name: 'Firedancer Node',
        description: 'Independent C validator. 1M TPS on commodity hardware. Client diversity achieved.',
        rarity: 'rare',
        cost: 220,
        maxCopies: 1,
        effects: [
            { kind: 'forceSuit', suit: 'Sol' },
            { kind: 'percentScore', percent: 0.12 },
        ],
        tags: ['combo', 'utility'],
    },
    {
        id: 'phishing-kit',
        name: 'Phishing Kit',
        description: 'Connect wallet to claim your free... oh no.',
        rarity: 'rare',
        cost: 220,
        maxCopies: 1,
        effects: [
            { kind: 'handTypeFlat', hand: 'Twin Rugs', amount: 110 },
            { kind: 'percentScore', percent: 0.12 },
        ],
        tags: ['combo'],
    },
    {
        id: 'parrot-protocol',
        name: 'Parrot Protocol',
        description: 'Synthetic debt, real exit. Devs took the treasury and vanished.',
        rarity: 'rare',
        cost: 210,
        maxCopies: 1,
        effects: [
            { kind: 'scorePerHeart', percentPerHeart: 0.1 },
            { kind: 'chipsOnClear', amount: 80 },
        ],
        tags: ['economy', 'defensive'],
    },
    {
        id: 'liquidity-mining',
        name: 'Liquidity Mining',
        description: 'Provide liquidity, earn rewards. Simple as.',
        rarity: 'rare',
        cost: 235,
        maxCopies: 1,
        effects: [
            { kind: 'chipsOnClear', amount: 140 },
            { kind: 'chipsOnFail', amount: 40 },
        ],
        tags: ['economy'],
    },
    {
        id: 'sandwich-attack',
        name: 'Sandwich Attack',
        description: 'Front-run, back-run, extract value. DEX life.',
        rarity: 'rare',
        cost: 250,
        maxCopies: 1,
        effects: [
            { kind: 'handTypePercent', hand: 'Triple Top', percent: 0.3 },
            { kind: 'chipsOnClear', amount: 60 },
        ],
        tags: ['combo', 'aggressive'],
    },
    {
        id: 'on-chain-sleuth',
        name: 'On-chain Sleuth',
        description: 'Following whale wallets for alpha. ZachXBT energy.',
        rarity: 'rare',
        cost: 240,
        maxCopies: 1,
        effects: [
            { kind: 'percentScore', percent: 0.24 },
            { kind: 'handTypeFlat', hand: 'Exit Liquidity', amount: 80 },
        ],
        tags: ['aggressive'],
    },
    {
        id: 'insider-trading',
        name: 'Insider Trading',
        description: 'Some wallets just know things before everyone else.',
        rarity: 'rare',
        cost: 210,
        maxCopies: 1,
        effects: [
            { kind: 'heartsOnClear', amount: 1 },
            { kind: 'chipsOnFail', amount: 45 },
        ],
        tags: ['defensive', 'economy'],
    },
    {
        id: 'trump-launch',
        name: '$TRUMP Launch',
        description: 'The president launched a memecoin on Solana. SOL hit $295. Then -93%.',
        rarity: 'legendary',
        cost: 280,
        maxCopies: 1,
        effects: [{ kind: 'freezeOpponentOnClear' }, { kind: 'percentScore', percent: 0.15 }],
        tags: ['legendary', 'aggressive', 'pvp'],
    },
    {
        id: 'jupiter-exchange',
        name: 'Jupiter Exchange',
        description: 'Just Use Jupiter! Best swaps in DeFi. JUP token? Down 90%. Rev-share? Never heard of her.',
        rarity: 'legendary',
        cost: 380,
        maxCopies: 1,
        effects: [
            { kind: 'chipsOnClear', amount: 150 },
            { kind: 'opponentHeartDamageOnClear', amount: 1 },
        ],
        tags: ['legendary', 'aggressive', 'pvp'],
    },
    {
        id: 'three-arrows-capital',
        name: 'Mango Exploit',
        description: "Pumped MNGO perps 1000%, borrowed $114M. 'Highly profitable trading strategy.'",
        rarity: 'legendary',
        cost: 380,
        maxCopies: 1,
        effects: [
            { kind: 'opponentHeartDamageOnClear', amount: 1 },
            { kind: 'chipsOnClear', amount: 100 },
        ],
        tags: ['legendary', 'aggressive', 'pvp'],
    },
    {
        id: 'terra-luna',
        name: 'Wormhole Heist',
        description: '$320M minted from thin air. The biggest bridge payday in history.',
        rarity: 'legendary',
        cost: 340,
        maxCopies: 1,
        effects: [
            { kind: 'heartStealOnClear', amount: 1 },
            { kind: 'flatScore', amount: 50 },
        ],
        tags: ['legendary', 'aggressive', 'pvp'],
    },
    {
        id: 'sbf-alameda',
        name: "Alameda's SOL Bags",
        description: '982 million in locked SOL. Customer deposits? What customer deposits?',
        rarity: 'legendary',
        cost: 360,
        maxCopies: 1,
        effects: [
            { kind: 'percentScore', percent: 0.35 },
            { kind: 'chipsOnFail', amount: 50 },
        ],
        tags: ['legendary', 'aggressive'],
    },
    {
        id: 'do-kwon-ego',
        name: "Toly's Timeline",
        description: 'One mass-reply tweet and SOL pumps 15%. Deploy more capital. Steady lads.',
        rarity: 'legendary',
        cost: 370,
        maxCopies: 1,
        effects: [
            { kind: 'scorePerHeart', percentPerHeart: 0.2 },
            { kind: 'heartsOnClear', amount: 1 },
            { kind: 'chipsOnFail', amount: 80 },
        ],
        tags: ['legendary', 'defensive'],
    },
    {
        id: 'celsius-freeze',
        name: 'Slope Wallet Drain',
        description: 'Logging private keys in plaintext. 9,231 wallets emptied in minutes.',
        rarity: 'legendary',
        cost: 350,
        maxCopies: 1,
        effects: [
            { kind: 'opponentHeartDamageOnClear', amount: 1 },
            { kind: 'flatScore', amount: 80 },
        ],
        tags: ['legendary', 'aggressive', 'pvp'],
    },
    {
        id: 'cz-tweet',
        name: "CZ's Tweet",
        description: '"4" - And just like that, billions evaporated.',
        rarity: 'legendary',
        cost: 340,
        maxCopies: 1,
        effects: [
            { kind: 'percentScore', percent: 0.25 },
            { kind: 'chipsOnClear', amount: 120 },
            { kind: 'chipsOnFail', amount: 80 },
        ],
        tags: ['legendary', 'economy'],
    },
    {
        id: 'solana-foundation',
        name: 'Solana Foundation',
        description: 'Rose from the ashes of FTX. The network state is strong.',
        rarity: 'legendary',
        cost: 330,
        maxCopies: 1,
        effects: [
            { kind: 'heartsOnClear', amount: 2 },
            { kind: 'percentScore', percent: 0.2 },
        ],
        tags: ['legendary', 'defensive'],
    },
    {
        id: 'pump-fun-factory',
        name: 'Pump.fun Factory',
        description: 'Anyone can make a token. Few will make it. Chips either way.',
        rarity: 'legendary',
        cost: 360,
        maxCopies: 1,
        effects: [
            { kind: 'percentScore', percent: 0.22 },
            { kind: 'chipsOnClear', amount: 110 },
            { kind: 'chipsOnFail', amount: 70 },
        ],
        tags: ['legendary', 'economy'],
    },
    {
        id: 'ftx-collapse',
        name: 'FTX Collapse',
        description: "When the music stops, someone's left holding the bag. Damage your opponent.",
        rarity: 'legendary',
        cost: 380,
        maxCopies: 1,
        effects: [
            { kind: 'opponentHeartDamageOnClear', amount: 1 },
            { kind: 'percentScore', percent: 0.1 },
        ],
        tags: ['legendary', 'aggressive', 'pvp'],
    },
    {
        id: 'the-rug-pull',
        name: 'The Rug Pull',
        description: "Yoink! Each clear siphons a heart straight from your opponent's wallet.",
        rarity: 'legendary',
        cost: 400,
        maxCopies: 1,
        effects: [{ kind: 'heartStealOnClear', amount: 1 }],
        tags: ['legendary', 'aggressive', 'pvp'],
    },
    {
        id: 'market-manipulator',
        name: 'Market Manipulator',
        description: 'Coordinated dumps hurt everyone else. Your opponent loses hearts while you profit.',
        rarity: 'rare',
        cost: 280,
        maxCopies: 1,
        effects: [
            { kind: 'opponentHeartDamageOnClear', amount: 1 },
            { kind: 'flatScore', amount: 50 },
        ],
        tags: ['rare', 'aggressive', 'pvp'],
    },
    // =====================
    // AWAKENED JOKERS (1st Evolution Tier)
    // =====================
    {
        id: 'whale-wallet',
        name: 'Whale Wallet',
        description: 'Your bags are growing. The more you HODL, the bigger your stack.',
        rarity: 'uncommon',
        cost: 0, // Cannot be purchased, only evolved into
        maxCopies: 1,
        effects: [
            { kind: 'scorePerHeart', percentPerHeart: 0.22 },
            { kind: 'flatScore', amount: 15 },
        ],
        tags: ['economy', 'evolved'],
        evolution: {
            tier: 'awakened',
            baseJokerId: 'diamond-hands',
            nextEvolution: {
                condition: {
                    kind: 'winMatch',
                    description: 'Win with 4+ hearts remaining',
                    condition: 'hearts >= 4',
                },
                evolvesTo: 'gigachad-whale',
            },
        },
    },
    {
        id: 'mega-validator',
        name: 'Mega Validator',
        description: 'Your stake is growing. Top 100 validator energy.',
        rarity: 'uncommon',
        cost: 0,
        maxCopies: 1,
        effects: [
            { kind: 'chipsOnClear', amount: 180 },
            { kind: 'flatScore', amount: 25 },
        ],
        tags: ['economy', 'evolved'],
        evolution: {
            tier: 'awakened',
            baseJokerId: 'validator-rewards',
            nextEvolution: {
                condition: {
                    kind: 'chipsEarned',
                    description: 'Reach 800 chips banked',
                    target: 800,
                },
                evolvesTo: 'lido-giant',
            },
        },
    },
    {
        id: 'diamond-convert',
        name: 'Diamond Convert',
        description: 'Once paper, now diamond. Exit Liquidity hands hit different.',
        rarity: 'uncommon',
        cost: 0,
        maxCopies: 1,
        effects: [
            { kind: 'handTypeFlat', hand: 'Exit Liquidity', amount: 65 },
            { kind: 'percentScore', percent: 0.15 },
        ],
        tags: ['utility', 'evolved'],
        evolution: {
            tier: 'awakened',
            baseJokerId: 'paper-hands',
            nextEvolution: {
                condition: {
                    kind: 'scoreThreshold',
                    description: 'Score 300+ with Exit Liquidity',
                    target: 300,
                },
                evolvesTo: 'unshakeable',
            },
        },
    },
    {
        id: 'full-degen',
        name: 'Full Degen',
        description: 'No stop losses. No fear. Only gains.',
        rarity: 'uncommon',
        cost: 0,
        maxCopies: 1,
        effects: [
            { kind: 'percentScore', percent: 0.18 },
            { kind: 'chipsOnClear', amount: 55 },
        ],
        tags: ['aggressive', 'evolved'],
        evolution: {
            tier: 'awakened',
            baseJokerId: 'fomo-buy',
            nextEvolution: {
                condition: {
                    kind: 'consecutiveClears',
                    description: 'Clear 5 hands in a row',
                    target: 5,
                },
                evolvesTo: 'based-maximalist',
            },
        },
    },
    {
        id: 'accumulation-whale',
        name: 'Accumulation Whale',
        description: 'Quiet accumulation phase. The charts will catch up.',
        rarity: 'uncommon',
        cost: 0,
        maxCopies: 1,
        effects: [
            { kind: 'percentScore', percent: 0.1 },
            { kind: 'chipsOnClear', amount: 70 },
        ],
        tags: ['economy', 'evolved'],
        evolution: {
            tier: 'awakened',
            baseJokerId: 'dca-bot',
            nextEvolution: {
                condition: {
                    kind: 'triggerCount',
                    description: 'Trigger 10 more times',
                    target: 10,
                },
                evolvesTo: 'whale-gang',
            },
        },
    },
    {
        id: 'bankruptcy-phoenix',
        name: 'Bankruptcy Phoenix',
        description: 'Lost it all and came back. The ultimate redemption arc.',
        rarity: 'uncommon',
        cost: 0,
        maxCopies: 1,
        effects: [
            { kind: 'chipsOnClear', amount: 85 },
            { kind: 'chipsOnFail', amount: 55 },
        ],
        tags: ['economy', 'evolved'],
        evolution: {
            tier: 'awakened',
            baseJokerId: 'rekt-insurance',
            nextEvolution: {
                condition: {
                    kind: 'chipsEarned',
                    description: 'Earn 600 more chips',
                    target: 600,
                },
                evolvesTo: 'wagmi-legend',
            },
        },
    },
    {
        id: 'infinite-degen',
        name: 'Infinite Degen',
        description: 'The degen spiral has no bottom. Keep compounding.',
        rarity: 'rare',
        cost: 0,
        maxCopies: 1,
        effects: [{ kind: 'percentScore', percent: 0.35 }],
        tags: ['aggressive', 'evolved'],
        evolution: {
            tier: 'awakened',
            baseJokerId: 'degen-chain',
            nextEvolution: {
                condition: {
                    kind: 'scoreThreshold',
                    description: 'Score 600+ with it active',
                    target: 600,
                },
                evolvesTo: 'eternal-degen',
            },
        },
    },
    {
        id: 'jupiter-bags',
        name: 'Jupiter Bags',
        description: 'Best products in DeFi. Token down 80%. At least the swap works.',
        rarity: 'rare',
        cost: 0,
        maxCopies: 1,
        effects: [
            { kind: 'heartsOnClear', amount: 1 },
            { kind: 'flatScore', amount: 40 },
            { kind: 'percentScore', percent: 0.08 },
        ],
        tags: ['defensive', 'evolved'],
        evolution: {
            tier: 'awakened',
            baseJokerId: 'jito-airdrop',
            nextEvolution: {
                condition: {
                    kind: 'heartsAbove',
                    description: 'Maintain 5 hearts for 3 turns',
                    minHearts: 5,
                    triggerCount: 3,
                },
                evolvesTo: 'divine-yield',
            },
        },
    },
    {
        id: 'wif-army',
        name: 'WIF Army',
        description: 'The dog with a hat. Twin Rugs go absolutely nuclear.',
        rarity: 'rare',
        cost: 0,
        maxCopies: 1,
        effects: [
            { kind: 'handTypePercent', hand: 'Twin Rugs', percent: 0.6 },
            { kind: 'chipsOnClear', amount: 90 },
        ],
        tags: ['aggressive', 'evolved'],
        evolution: {
            tier: 'awakened',
            baseJokerId: 'bonk-army',
            nextEvolution: {
                condition: {
                    kind: 'handTypeCount',
                    description: 'Play 5 Twin Rugs total',
                    handType: 'Twin Rugs',
                    target: 5,
                },
                evolvesTo: 'doge-maxi',
            },
        },
    },
    {
        id: 'whale-alpha',
        name: 'Whale Alpha',
        description: 'The alpha calls are hitting. Exit Liquidity domination.',
        rarity: 'rare',
        cost: 0,
        maxCopies: 1,
        effects: [
            { kind: 'handTypeFlat', hand: 'Exit Liquidity', amount: 120 },
            { kind: 'handTypePercent', hand: 'Exit Liquidity', percent: 0.22 },
        ],
        tags: ['utility', 'evolved'],
        evolution: {
            tier: 'awakened',
            baseJokerId: 'ct-alpha',
            nextEvolution: {
                condition: {
                    kind: 'scoreThreshold',
                    description: 'Score 350+ with Exit Liquidity',
                    target: 350,
                },
                evolvesTo: 'alpha-god',
            },
        },
    },
    // =====================
    // ASCENDED JOKERS (2nd Evolution Tier - Final Form)
    // =====================
    {
        id: 'gigachad-whale',
        name: 'Gigachad Whale',
        description: 'Top wallet holder energy. Your hands print money.',
        rarity: 'rare',
        cost: 0,
        maxCopies: 1,
        effects: [
            { kind: 'scorePerHeart', percentPerHeart: 0.3 },
            { kind: 'flatScore', amount: 30 },
            { kind: 'chipsOnClear', amount: 40 },
        ],
        tags: ['economy', 'evolved', 'ascended'],
        evolution: {
            tier: 'ascended',
            baseJokerId: 'diamond-hands',
        },
    },
    {
        id: 'lido-giant',
        name: 'Marinade Giant',
        description: 'mSOL staked since day one. Liquid staking OG. Validators love you.',
        rarity: 'legendary',
        cost: 0,
        maxCopies: 1,
        effects: [
            { kind: 'chipsOnClear', amount: 200 },
            { kind: 'chipsOnFail', amount: 50 },
            { kind: 'flatScore', amount: 40 },
        ],
        tags: ['economy', 'evolved', 'ascended'],
        evolution: {
            tier: 'ascended',
            baseJokerId: 'validator-rewards',
        },
    },
    {
        id: 'unshakeable',
        name: 'Unshakeable',
        description: 'Nothing can shake these diamond hands. Exit Liquidity perfection.',
        rarity: 'rare',
        cost: 0,
        maxCopies: 1,
        effects: [
            { kind: 'handTypeFlat', hand: 'Exit Liquidity', amount: 100 },
            { kind: 'percentScore', percent: 0.2 },
            { kind: 'flatScore', amount: 25 },
        ],
        tags: ['utility', 'evolved', 'ascended'],
        evolution: {
            tier: 'ascended',
            baseJokerId: 'paper-hands',
        },
    },
    {
        id: 'based-maximalist',
        name: 'Based Maximalist',
        description: 'All in on one chain. One mission. One destiny.',
        rarity: 'rare',
        cost: 0,
        maxCopies: 1,
        effects: [
            { kind: 'percentScore', percent: 0.25 },
            { kind: 'chipsOnClear', amount: 80 },
            { kind: 'flatScore', amount: 35 },
        ],
        tags: ['aggressive', 'evolved', 'ascended'],
        evolution: {
            tier: 'ascended',
            baseJokerId: 'fomo-buy',
        },
    },
    {
        id: 'whale-gang',
        name: 'Whale Gang',
        description: 'Coordinated accumulation complete. The pump begins.',
        rarity: 'rare',
        cost: 0,
        maxCopies: 1,
        effects: [
            { kind: 'percentScore', percent: 0.15 },
            { kind: 'chipsOnClear', amount: 100 },
            { kind: 'flatScore', amount: 30 },
        ],
        tags: ['economy', 'evolved', 'ascended'],
        evolution: {
            tier: 'ascended',
            baseJokerId: 'dca-bot',
        },
    },
    {
        id: 'wagmi-legend',
        name: 'WAGMI Legend',
        description: 'You made it. Against all odds. Immune to rekt.',
        rarity: 'legendary',
        cost: 0,
        maxCopies: 1,
        effects: [
            { kind: 'chipsOnClear', amount: 130 },
            { kind: 'chipsOnFail', amount: 90 },
            { kind: 'percentScore', percent: 0.1 },
        ],
        tags: ['economy', 'evolved', 'ascended'],
        evolution: {
            tier: 'ascended',
            baseJokerId: 'rekt-insurance',
        },
    },
    {
        id: 'eternal-degen',
        name: 'Eternal Degen',
        description: 'There is no escape from the degen lifestyle. Embrace it.',
        rarity: 'legendary',
        cost: 0,
        maxCopies: 1,
        effects: [
            { kind: 'percentScore', percent: 0.4 },
            { kind: 'flatScore', amount: 50 },
        ],
        tags: ['aggressive', 'evolved', 'ascended'],
        evolution: {
            tier: 'ascended',
            baseJokerId: 'degen-chain',
        },
    },
    {
        id: 'divine-yield',
        name: 'Divine Yield',
        description: 'DeFi enlightenment achieved. Passive income from the heavens.',
        rarity: 'legendary',
        cost: 0,
        maxCopies: 1,
        effects: [
            { kind: 'heartsOnClear', amount: 2 },
            { kind: 'flatScore', amount: 60 },
            { kind: 'percentScore', percent: 0.12 },
        ],
        tags: ['defensive', 'evolved', 'ascended'],
        evolution: {
            tier: 'ascended',
            baseJokerId: 'jito-airdrop',
        },
    },
    {
        id: 'doge-maxi',
        name: 'Doge Maxi',
        description: 'From BONK to WIF to DOGE. The meme coin trilogy complete.',
        rarity: 'legendary',
        cost: 0,
        maxCopies: 1,
        effects: [
            { kind: 'handTypePercent', hand: 'Twin Rugs', percent: 0.6 },
            { kind: 'chipsOnClear', amount: 120 },
            { kind: 'percentScore', percent: 0.1 },
        ],
        tags: ['aggressive', 'evolved', 'ascended'],
        evolution: {
            tier: 'ascended',
            baseJokerId: 'bonk-army',
        },
    },
    {
        id: 'alpha-god',
        name: 'Alpha God',
        description: 'Every call hits. Every Exit Liquidity play prints. Godhood achieved.',
        rarity: 'legendary',
        cost: 0,
        maxCopies: 1,
        effects: [
            { kind: 'handTypeFlat', hand: 'Exit Liquidity', amount: 160 },
            { kind: 'handTypePercent', hand: 'Exit Liquidity', percent: 0.3 },
            { kind: 'flatScore', amount: 40 },
        ],
        tags: ['utility', 'evolved', 'ascended'],
        evolution: {
            tier: 'ascended',
            baseJokerId: 'ct-alpha',
        },
    },
];
export const CONSUMABLE_POOL = [
    {
        id: 'alpha-leak',
        name: 'Alpha Leak',
        description: 'Insider info just dropped in the group chat. +1 draw and discard.',
        cost: 90,
        effects: [
            { kind: 'addDraws', amount: 1 },
            { kind: 'addDiscards', amount: 1 },
        ],
        tags: ['utility'],
    },
    {
        id: 'wallet-drainer',
        name: 'Wallet Drainer',
        description: 'Unlimited token approvals? What could go wrong? +2 draws.',
        cost: 120,
        effects: [{ kind: 'addDraws', amount: 2 }],
        tags: ['aggressive'],
    },
    {
        id: 'airdrop-claim',
        name: 'Airdrop Claim',
        description: 'Free money glitch activated. Check eligibility. +250 chips.',
        cost: 0,
        effects: [{ kind: 'addChips', amount: 250 }],
        tags: ['economy'],
    },
    {
        id: 'wagmi-energy',
        name: 'WAGMI Energy',
        description: "We're All Gonna Make It. Community strength restores hope.",
        cost: 160,
        effects: [
            { kind: 'addHearts', amount: 1 },
            { kind: 'scoreMultiplier', percent: 0.15 },
        ],
        tags: ['defensive'],
    },
    {
        id: 'vc-unlock',
        name: 'VC Unlock',
        description: 'Cliff ended. Big bags hitting the market. +300 chips.',
        cost: 0,
        effects: [{ kind: 'addChips', amount: 300 }],
        tags: ['economy'],
    },
    {
        id: 'time-in-market',
        name: 'Time in Market',
        description: 'Time in market > timing the market. Stay patient, stay winning.',
        cost: 130,
        effects: [
            { kind: 'addDraws', amount: 2 },
            { kind: 'addDiscards', amount: 1 },
        ],
        tags: ['utility'],
    },
    {
        id: 'leverage-up',
        name: 'Leverage Up',
        description: '10x long opened. Diamond hands required. +30% score boost.',
        cost: 180,
        effects: [{ kind: 'scoreMultiplier', percent: 0.3 }],
        tags: ['aggressive'],
    },
    {
        id: 'safu-fund',
        name: 'SAFU Fund',
        description: 'Funds are safe. CZ promised. +2 hearts instantly.',
        cost: 210,
        effects: [{ kind: 'addHearts', amount: 2 }],
        tags: ['defensive'],
    },
    {
        id: 'copium-dose',
        name: 'Copium Dose',
        description: "It's not a loss until you sell. *inhales deeply*",
        cost: 150,
        effects: [
            { kind: 'addDraws', amount: 1 },
            { kind: 'scoreMultiplier', percent: 0.2 },
        ],
        tags: ['utility'],
    },
    {
        id: 'buyback-pump',
        name: 'Buyback Pump',
        description: 'Treasury buying back tokens. Number go up technology.',
        cost: 190,
        effects: [
            { kind: 'addHearts', amount: 1 },
            { kind: 'addDiscards', amount: 1 },
        ],
        tags: ['defensive'],
    },
    {
        id: 'arbitrage-bot',
        name: 'Arbitrage Bot',
        description: "Risk-free profit they said. Until it isn't.",
        cost: 200,
        effects: [
            { kind: 'addChips', amount: 200 },
            { kind: 'scoreMultiplier', percent: 0.25 },
        ],
        tags: ['aggressive'],
    },
    {
        id: 'bridge-exploit',
        name: 'Bridge Exploit',
        description: 'Wormhole, Ronin, Nomad... bridges gonna bridge. -1 opponent heart.',
        cost: 250,
        effects: [{ kind: 'opponentHeartDamage', amount: 1 }],
        tags: ['aggressive', 'pvp'],
    },
    {
        id: 'fud-campaign',
        name: 'FUD Campaign',
        description: 'Is this a scam? A thread 🧵. Damage opponent, boost yourself.',
        cost: 220,
        effects: [
            { kind: 'opponentHeartDamage', amount: 1 },
            { kind: 'scoreMultiplier', percent: 0.15 },
        ],
        tags: ['aggressive', 'pvp'],
    },
];
export const SERVICE_POOL = [
    {
        id: 'restore-heart',
        name: 'Restore Heart',
        description: 'Recover one heart.',
        cost: 250,
    },
    {
        id: 'bank-boost',
        name: 'Bank Boost',
        description: 'Add 250 chips to your bankroll.',
        cost: 0,
    },
    {
        id: 'hand-upgrade',
        name: 'Hand Upgrade',
        description: 'Increase Full House multiplier by +1.',
        cost: 220,
    },
];
// =====================
// Joker Evolution Utilities
// =====================
/**
 * Get a joker definition by ID
 */
export const getJokerById = (id) => {
    return JOKER_POOL.find((j) => j.id === id);
};
/**
 * Get all base jokers (those that can evolve but aren't evolved)
 */
export const getBaseJokers = () => {
    return JOKER_POOL.filter((j) => j.evolution?.tier === 'base' && j.evolution?.nextEvolution);
};
/**
 * Get all evolved jokers (awakened or ascended)
 */
export const getEvolvedJokers = () => {
    return JOKER_POOL.filter((j) => j.evolution?.tier === 'awakened' || j.evolution?.tier === 'ascended');
};
/**
 * Get jokers that can appear in shop (excludes evolved variants)
 */
export const getShopEligibleJokers = () => {
    return JOKER_POOL.filter((j) => j.cost > 0);
};
/**
 * Get the evolution chain for a base joker
 */
export const getEvolutionChain = (baseJokerId) => {
    const chain = [];
    let current = getJokerById(baseJokerId);
    while (current) {
        chain.push(current);
        const nextId = current.evolution?.nextEvolution?.evolvesTo;
        current = nextId ? getJokerById(nextId) : undefined;
    }
    return chain;
};
/**
 * Get the base joker ID for any joker in an evolution chain
 */
export const getBaseJokerIdForEvolution = (jokerId) => {
    const joker = getJokerById(jokerId);
    if (!joker)
        return jokerId;
    // If it has a baseJokerId, return that (it's an evolved form)
    if (joker.evolution?.baseJokerId) {
        return joker.evolution.baseJokerId;
    }
    // Otherwise it's either a base joker or non-evolving
    return jokerId;
};
/**
 * Check if a joker can evolve further
 */
export const canEvolve = (jokerId) => {
    const joker = getJokerById(jokerId);
    return !!joker?.evolution?.nextEvolution;
};
/**
 * Get the evolution tier display name
 */
export const getEvolutionTierDisplayName = (tier) => {
    switch (tier) {
        case 'base':
            return 'Base';
        case 'awakened':
            return 'Awakened';
        case 'ascended':
            return 'Ascended';
        default:
            return 'Unknown';
    }
};
/**
 * Get tier color for UI display
 */
export const getEvolutionTierColor = (tier) => {
    switch (tier) {
        case 'base':
            return '#9CA3AF'; // gray
        case 'awakened':
            return '#60A5FA'; // blue
        case 'ascended':
            return '#F59E0B'; // gold
        default:
            return '#9CA3AF';
    }
};
//# sourceMappingURL=gameData.js.map